/* eslint-disable import/prefer-default-export */
import nodeFetch from 'node-fetch'

const isSuccessful = (status) => status >= 200 && status < 300
const NOT_FOUND = 404

const commonHeaders = {
  Accept: `application/vnd.picto-public-v2+json`,
  'Content-Type': 'application/json',
  Authorization: process.env.RAZZLE_APP_AUTH,
}

export const fetch = (endpoint, headers = {}) =>
  nodeFetch(`${process.env.RAZZLE_API_URL}${endpoint}`, {
    headers: {
      ...commonHeaders,
      ...headers,
    },
  }).then((response) => {
    const { status } = response

    if (!isSuccessful(status)) {
      switch (status) {
        case NOT_FOUND:
          throw new Error(
            `[fetch] Entry not found, please check your UID.\nURL: ${process.env.RAZZLE_API_URL}${endpoint}`,
          )
        default:
          throw new Error('[fetch] Unsuccessful request')
      }
    }
    // no body
    if (status !== 204) {
      return response.json()
    }
    return Promise.resolve(response)
  })
